// @ts-nocheck
import { Box } from '@mui/material';
import { Clock, MapPin, CheckCircle, Notebook } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { ServicePropTypes } from '../../types';
import Editor from '../../../../../Editor/Editor';
import { formatTime } from '../../../../../../utils/dateUtility';
import ImageSection from '../Components/ImageSection';
import AttachmentNotice from '../Components/AttachmentNotice';
import IconSection from '../Components/IconSection';
import useComponentHeight from '../../../../../../hooks/useComponentHeight';
import { ensureHttps } from '../../../../../../utils/urlHelper';

const TransferService = ({
  servicetype,
  servicefields,
  tripdetaileddayserviceid,
  tenantsettings,
  icon
}) => {
  const { ref, height } = useComponentHeight();
  const { t } = useTranslation(['common', 'services']);
  const columnFields = [
    'COMPANYNAME',
    'DRIVERNAME',
    'PHONENUMBER',
    'LINK',
    'PICKUPADDRESS',
    'PICKUPTIME',
    'DROPOFFADDRESS',
    'DROPOFFTIME'
  ];
  const hasColumnFieldData = columnFields.some(
    (field) => !!servicefields[field]
  );

  return (
    <Box
      className='service-section'
      id={`service-section-transfer-${tripdetaileddayserviceid}`}
      fontFamily={tenantsettings?.bodyfont || 'inherit'}
      ref={ref}
    >
      <Box className='service-section__icon-name'>
        <IconSection icon={icon} height={height} />
        <h3
          className='service-section__name'
          style={{ fontFamily: tenantsettings?.headingfont || 'inherit' }}
        >
          {servicetype.name}
        </h3>
      </Box>

      <Box className='service-section__content'>
        {servicefields.TITLE && (
          <h5
            className='service-section__title'
            style={{ fontFamily: tenantsettings?.headingfont || 'inherit' }}
          >
            {servicefields.TITLE}
          </h5>
        )}

        <Box className='service-section___column-info'>
          {(servicefields.COMPANYNAME ||
            servicefields.DRIVERNAME ||
            servicefields.PHONENUMBER ||
            servicefields.LINK) && (
            <Box className='service-section___column'>
              <Box className='service-section___column-info__icon'>
                <Notebook />
              </Box>
              <Box>
                {servicefields.COMPANYNAME && (
                  <p className='service-section__label-value'>
                    <span>{t('Company')}:</span> {servicefields.COMPANYNAME}
                  </p>
                )}
                {servicefields.DRIVERNAME && (
                  <p className='service-section__label-value'>
                    <span>{t('Driver Name')}:</span> {servicefields.DRIVERNAME}
                  </p>
                )}
                {servicefields.PHONENUMBER && (
                  <p className='service-section__label-value'>
                    <span>{t('Contact Tel')}:</span> {servicefields.PHONENUMBER}
                  </p>
                )}
                {servicefields.LINK && (
                  <p className='service-section__label-value'>
                    <a
                      href={ensureHttps(servicefields.LINK)}
                      rel='noreferrer'
                      target='_blank'
                    >
                      {t('Website')}
                    </a>
                  </p>
                )}
              </Box>
            </Box>
          )}

          {(servicefields.PICKUPADDRESS || servicefields.DROPOFFADDRESS) && (
            <Box className='service-section___column'>
              <Box className='service-section___column-info__icon'>
                <MapPin />
              </Box>
              <Box>
                {servicefields.PICKUPADDRESS && (
                  <p className='service-section__label-value'>
                    <span>{t('Pick Up Location')}:</span>{' '}
                    {servicefields.PICKUPADDRESS}
                  </p>
                )}
                {servicefields.DROPOFFADDRESS && (
                  <p className='service-section__label-value'>
                    <span>{t('Drop Off Location')}:</span>{' '}
                    {servicefields.DROPOFFADDRESS}
                  </p>
                )}
              </Box>
            </Box>
          )}

          {(servicefields.PICKUPTIME || servicefields.DROPOFFTIME) && (
            <Box className='service-section___column'>
              <Box className='service-section___column-info__icon'>
                <Clock />
              </Box>
              <Box>
                {servicefields.PICKUPTIME && (
                  <p className='service-section__label-value'>
                    <span>{t('Pick Up Time')}:</span>{' '}
                    {formatTime(servicefields.PICKUPTIME)}
                  </p>
                )}
                {servicefields.DROPOFFTIME && (
                  <p className='service-section__label-value'>
                    <span>{t('Drop Off Time')}:</span>{' '}
                    {formatTime(servicefields.DROPOFFTIME)}
                  </p>
                )}
              </Box>
            </Box>
          )}
        </Box>

        <Box
          className={`service-section__description-notes ${hasColumnFieldData ? 'spacing' : ''}`}
        >
          {servicefields?.DESCRIPTION && (
            <Editor
              id={`service-section-transfer-${tripdetaileddayserviceid}-description`}
              content={servicefields?.DESCRIPTION}
              editable={false}
              isPreviewing={true}
              className='service-section__description'
              style={{
                fontFamily: tenantsettings?.bodyfont || 'inherit'
              }}
            />
          )}

          {servicefields?.CONFIRMATIONINFORMATION && (
            <Box className='service-section__confirmation'>
              <p>
                <span>{t('Confirmation #')}:</span>{' '}
                {servicefields.CONFIRMATIONINFORMATION}
              </p>
            </Box>
          )}

          <AttachmentNotice attachments={servicefields?.UPLOADATTACHMENTS} />

          {servicefields?.MEALSINCLUDED && (
            <Box className='service-section__include-values'>
              {servicefields?.MEALSINCLUDED?.map((meal, index) => (
                <Box
                  className='service-section__include-values__item'
                  key={`meals-included-${meal?.toLowerCase()}-${index}`}
                >
                  <CheckCircle color='rgba(56, 211, 133, 1)' />
                  <p>{meal}</p>
                </Box>
              ))}
            </Box>
          )}
        </Box>

        <ImageSection
          images={servicefields?.UPLOADIMAGES}
          hideInPdf={tenantsettings?.showImagesInPdf === false}
        />
      </Box>
    </Box>
  );
};

TransferService.propTypes = ServicePropTypes;

export default TransferService;
